import type { FC } from 'react';
import type { ModalHeaderProps } from '../../types';

const ModalHeader: FC<ModalHeaderProps> = ({ onClose }) => (
  <div className="schedule-meeting-modal__header">
    <div className="schedule-meeting-modal__title">Schedule a meeting</div>
    <button type="button" onClick={onClose} className="schedule-meeting-modal__close-button">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        className="schedule-meeting-modal__close-icon"
      >
        <title>Close</title>
        <path d="M15.25 4.75833C14.925 4.43333 14.4 4.43333 14.075 4.75833L9.99998 8.825L5.92498 4.75C5.59998 4.425 5.07498 4.425 4.74998 4.75C4.42498 5.075 4.42498 5.6 4.74998 5.925L8.82498 10L4.74998 14.075C4.42498 14.4 4.42498 14.925 4.74998 15.25C5.07498 15.575 5.59998 15.575 5.92498 15.25L9.99998 11.175L14.075 15.25C14.4 15.575 14.925 15.575 15.25 15.25C15.575 14.925 15.575 14.4 15.25 14.075L11.175 10L15.25 5.925C15.5666 5.60833 15.5666 5.075 15.25 4.75833Z" />
      </svg>
    </button>
  </div>
);

export default ModalHeader;
